export var ART_STATUS_UPDATED_MESSAGE = "ART_STATUS_UPDATED";
export function notifyOpenerArtUpdated() {
    if (window.opener) {
        window.opener.postMessage({ type: ART_STATUS_UPDATED_MESSAGE }, window.location.origin);
    }
}
